import { useEffect, useState } from 'react';
import {
  clearTradeInQuote,
  readTradeInQuotes,
  removeTradeInQuote,
  TRADE_IN_QUOTE_EVENT,
  TRADE_IN_QUOTE_KEY,
  type TradeInQuoteT,
} from '@/lib/trade-in-quote';

export default function useTradeInQuote(): {
  /** The latest trade-in, which is the one the PDP shows. */
  quote: TradeInQuoteT | null;
  /** Every trade-in, oldest first. */
  quotes: TradeInQuoteT[];
  clear: () => void;
  remove: (quote: TradeInQuoteT) => void;
} {
  const [quotes, setQuotes] = useState<TradeInQuoteT[]>([]);

  useEffect(() => {
    const sync = () => {
      setQuotes(readTradeInQuotes());
    };

    sync();

    window.addEventListener(TRADE_IN_QUOTE_EVENT, sync);

    const onStorage = (event: StorageEvent) => {
      if (event.key === null || event.key === TRADE_IN_QUOTE_KEY) {
        sync();
      }
    };

    window.addEventListener('storage', onStorage);

    return () => {
      window.removeEventListener(TRADE_IN_QUOTE_EVENT, sync);
      window.removeEventListener('storage', onStorage);
    };
  }, []);

  // Both write to storage, which announces the change and syncs `quotes`.
  return {
    quote: quotes[quotes.length - 1] ?? null,
    quotes,
    clear: clearTradeInQuote,
    remove: removeTradeInQuote,
  };
}
